import CrudApi from 'glonass/core/CrudApi'

/**
 * Базовый класс для взаимодействия с корзиной и списком заказов.
 */
export default class CartApi extends CrudApi {
  /**
   * Добавляет товары в корзину пакетно.
   * @param {Array.<{offerId: Number, quantity: Number}>} items объект
   * @return {*} обновленное содержимое корзины
   */
  async put (items) {
    let {data} = await this.axios.post(this.entry, {items})

    return {
      data: data.data
    }
  }

  /**
   * Удаляет товары из корзины корзину пакетно.
   * @param {String} rowId rowId записи
   * @return {*} обновленное содержимое корзины
   */
  async remove (rowId) {
    let {data} = await this.axios.delete(this.entry + '/' + rowId)

    return {
      data: data.data
    }
  }
}



// WEBPACK FOOTER //
// ./dev-packages/Shop/assets/site/CartApi.js